import moment from "moment";

const getLocalUIDateFormat = () => {
  const local = Intl.DateTimeFormat().resolvedOptions().locale;
  if (local === "en-GB") {
    return "DD-MM-YYYY";
  }
  if (local === "en-US") {
    return "MM-DD-YYYY";
  }
};

const getLocalUIFileFormat = () => {
  const local = Intl.DateTimeFormat().resolvedOptions().locale;
  if (local === "en-GB") {
    return "DD-MM-YYYY-HH-mm-ss";
  }
  if (local === "en-US") {
    return "MM-DD-YYYY-HH-mm-ss";
  }
};

export const APIDateFormat = "DD MMMM YYYY";
export const APIDateTimeFormat = "DD MMMM YYYY HH:mm:ss";
export const defaultFromDate = moment().subtract(1, "days").startOf("day");
export const UIDateFormat = getLocalUIDateFormat();
export const UIDateTimeFormat = " HH:mm";
export const ComplianceAPIDateFormat = "YYYY-MM-DD";
export const  ComplianceUIDateTimeFormat = "YYYY-MM-DD HH:mm";
export const UITimeFormat = "HH:mm";
export const UIFileFormat = getLocalUIFileFormat();

export const mapPeriodsToSelect = (array) => {
  return array.map(({ name, fromDate, toDate }) => ({
    key: name,
    text: name,
    value: { fromDate, toDate },
  }));
};

export const getEventDate = (row) => {
  const fields = [
    row.customerInteraction?.interactionDate,
    row.observation?.observationDate,
    row.incident?.incidentDate,
    row.ageVerification?.ageVerificationDate,
    row.agcCheck?.timeChecked,
    row.dateCreated,
  ];

  for (const field of fields) {
    if (field) {
      return getFormattedDate(field);
    }
  }

  return "N/A";
};

export const getFormattedDate = (date) => {
  return moment(date).format(ComplianceUIDateTimeFormat);
};

export const getFormattedDateOnly = (date) => {
  const parsedDate = moment(date, ["DD/MM/YYYY HH:mm:ss", "MM/DD/YYYY HH:mm:ss", moment.ISO_8601], true);
  if (!parsedDate.isValid()) {
    return date;
  }
  return parsedDate.format(ComplianceAPIDateFormat);
};

export const getComplianceAPIDateFormat = (date) => {
  return moment(date).format(ComplianceAPIDateFormat);
};
